import '.aa{overflow:hidden;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.a1{width:100%;}.ssr-plugin'
import '.bb{position:relative;}.ssr-plugin'
import '.e1{width:max-content;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { ReactNode, useRef } from 'react'

export type ScrollingBannerProps = {
  children: ReactNode
  duration?: number
  gap?: string
  style?: Style
}

export const ScrollingBanner = ({
  children,
  duration = 30,
  gap = '2rem',
  style,
}: ScrollingBannerProps) => {
  const innerRef = useRef<HTMLDivElement>(null)

  return (
    <styled.div className="aa a a1 bb"
      style={{
        ...style,
      }}
      onMouseEnter={() => {
        if (innerRef.current) {
          innerRef.current.style.animationPlayState = 'paused'
        }
      }}
      onMouseLeave={() => {
        if (innerRef.current) {
          innerRef.current.style.animationPlayState = 'running'
        }
      }}
    >
      <styled.div className="a e1"
        ref={innerRef}
        style={{
          animation: `scroll-left ${duration}s linear infinite`,
          gap,
        }}
      >
        {children}
        {/* Duplicate content for seamless scrolling */}
        {children}
      </styled.div>
    </styled.div>
  )
}
